import React from 'react';
import { Button, ButtonProps } from '../../Button';
import { Dialog, DialogProps } from '../';
import { ModalLayout } from '../../ModalLayout';
import { ButtonGroup } from '../../ButtonGroup';

export interface DangerDialogProps
  extends Pick<DialogProps, 'onClose' | 'onCloseTransitionDone' | 'isOpen'> {
  /**
   * Textual heading of the dialog.
   */
  heading: React.ReactNode;
  /**
   * The message shown in the body of the dialog.
   */
  content: React.ReactNode;
  onPrimaryAction: ButtonProps<'button'>['onPress'];
  onSecondaryAction: ButtonProps<'button'>['onPress'];
  primaryActionLabel: string;
  secondaryActionLabel: string;
}

export const DangerDialog = ({
  heading,
  content,
  onPrimaryAction,
  onSecondaryAction,
  primaryActionLabel,
  secondaryActionLabel,
  ...otherProps
}: DangerDialogProps): JSX.Element => {
  return (
    <Dialog
      role="alertdialog"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      {...otherProps}
    >
      <ModalLayout
        header={<ModalLayout.Header hideCloseButton heading={heading} />}
        body={<ModalLayout.Body>{content}</ModalLayout.Body>}
        footer={
          <ModalLayout.Footer>
            <ButtonGroup>
              <Button variant="secondary" onPress={onSecondaryAction}>
                {secondaryActionLabel}
              </Button>
              <Button variant="danger" onPress={onPrimaryAction}>
                {primaryActionLabel}
              </Button>
            </ButtonGroup>
          </ModalLayout.Footer>
        }
      />
    </Dialog>
  );
};
